import { Link } from "wouter";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancelled() {
  return (
    <div data-testid="page-payment-cancelled" className="bg-spa-cream min-h-[80vh] flex items-center">
      <div className="container-spa py-24">
        <div className="max-w-xl mx-auto text-center card-spa">
          <div className="w-16 h-16 rounded-full bg-spa-sand flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-spa-gray" strokeWidth={1.5} />
          </div>
          <p className="overline mb-3">Payment cancelled</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-spa-dark leading-tight mb-5">No charge was made.</h1>
          <p className="text-spa-gray leading-relaxed mb-8">
            Your gift card was not purchased. You can try again any time — your details aren&apos;t saved.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link href="/gift-cards" data-testid="cancelled-retry-link">
              <button className="btn-primary">Try again <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></button>
            </Link>
            <Link href="/" data-testid="cancelled-home-link">
              <button className="btn-secondary">Back to home</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
